import moment from "moment";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from 'react-redux';
import { interval } from "rxjs";
import { getDateTimeInterval, getLabelConfigMsg } from "../../../../helpers/helpersIndex";
import designstrokeimg from '../../../../images/footer_stroke.png';
import designsolidimg from '../../../../images/footer.png';
import { IKIOSKModel, IKioskMessage, IkioskMenuIds, IkioskTokenType } from "../../../../models/kioskModel";
import { Ilanguages } from "../../../../models/utilitiesModel";
import { exitActionKiosk, getCurrentTimeRequest, menuTypeAction } from '../../../../store/actions';
let subscribe;

const ThemeTwoFooter: React.FC = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation("translations");
    const menuType: any = useSelector((state: any) => (state?.kioskReducer as IKIOSKModel)?.selectedPage) || IkioskMenuIds.LOGINPAGE;
    const tokenType: number = useSelector((state: any) => (state?.kioskReducer as IKIOSKModel)?.tokenType || 0);
    const language: string = useSelector((state: any) => (state?.kioskReducer as IKIOSKModel)?.language || Ilanguages.ENG);
    let currentDateandTime = useSelector((state: any) => (state?.kioskReducer as IKIOSKModel)?.currentDateAndTime || new Date());
    const selectedPage: any = useSelector((state) => (state.kioskReducer as IKIOSKModel)?.selectedPage);
    const kioskConfigMsgs: IKioskMessage[] = useSelector((state: any) => (state?.kioskReducer as IKIOSKModel)?.kioskConfigdata?.kioskMessage || []);
    


    const handleBack = (tokenType: number) => {
        if (tokenType === IkioskTokenType.CHECKIN) {
            dispatch(menuTypeAction(IkioskMenuIds.APPOINMENTS));
        }
        else if (tokenType === IkioskTokenType.OTHERSERVICES) {
            dispatch(menuTypeAction(IkioskMenuIds.OTHERSERVICES));
        }
        else if (tokenType === IkioskTokenType.WALKIN) {
            dispatch(menuTypeAction(IkioskMenuIds.APPOINMENTS));
        }
    };

    useEffect(() => {
        subscribe = interval(60000 * getDateTimeInterval()).subscribe(x => {
            dispatch(getCurrentTimeRequest());
            // dispatch(kioskIdAndGetTokensDataRequest(id, false))
        })
        return () => {
            if (subscribe)
                subscribe.unsubscribe();
        }
    }, [])

    return (
        <>
            <footer className='Kiosk_footer'>
                <div>
                    <small>{moment(currentDateandTime).format('dddd')}, {moment(currentDateandTime).format('DD MMMM YYYY')}</small>
                    <strong>{moment(currentDateandTime).format('hh:mm A')}</strong>
                    <span>{(getLabelConfigMsg(kioskConfigMsgs,language,"powered") || t('kiosktranslation.powered' + language))}</span>
                </div>
                <div className='d-flex gap-3 footer_buttons disabled'>
                    {(menuType === IkioskMenuIds.APPOINMENTS || menuType === IkioskMenuIds.OTHERSERVICES || menuType === IkioskMenuIds.DOBPAGE || (menuType !== IkioskMenuIds.WELCOMEPAGE && tokenType === IkioskTokenType.WALKIN)) &&
                        <div className={([IkioskMenuIds.OTHERSERVICES, IkioskMenuIds.DOBPAGE].includes(menuType)) ? 'back' : 'menu'} onClick={() => menuType === IkioskMenuIds.DOBPAGE ? dispatch(menuTypeAction(IkioskMenuIds.INPUTMOBILE)) : dispatch(menuTypeAction(IkioskMenuIds.WELCOMEPAGE))}><i className={[IkioskMenuIds.OTHERSERVICES, IkioskMenuIds.DOBPAGE].includes(menuType) ? 'icon_m42kiosk_back' : 'icon_m42kiosk_menu'}></i><span>{[IkioskMenuIds.OTHERSERVICES, IkioskMenuIds.DOBPAGE].includes(menuType) ? (getLabelConfigMsg(kioskConfigMsgs,language,"back") || t('kiosktranslation.back' + language)) : (getLabelConfigMsg(kioskConfigMsgs,language,"menu") || t('kiosktranslation.menu' + language))}</span></div>
                    }
                    {(menuType === IkioskMenuIds.TOKEN && (tokenType === IkioskTokenType.CHECKIN || tokenType === IkioskTokenType.OTHERSERVICES)) &&
                        <>
                            <div className='menu' onClick={() => dispatch(menuTypeAction(IkioskMenuIds.WELCOMEPAGE)) }><i className='icon_m42kiosk_menu'></i><span>{(getLabelConfigMsg(kioskConfigMsgs,language,"menu") || t('kiosktranslation.menu' + language))}</span></div>
                            <div className='back' onClick={() => handleBack(tokenType)}><i className='icon_m42kiosk_back'></i><span>{(getLabelConfigMsg(kioskConfigMsgs,language,"back") || t('kiosktranslation.back' + language))}</span></div>
                        </>}
                    {!(menuType === IkioskMenuIds.LOGINPAGE || menuType === IkioskMenuIds.PROMOTIONALSLIDE) &&
                        <div className='exit' onClick={() => dispatch(exitActionKiosk())}><i className='icon_m42kiosk_logout'></i><span>{(getLabelConfigMsg(kioskConfigMsgs,language,"exit") || t('kiosktranslation.exit' + language))}</span></div>}
                </div>
            </footer>
            <img src={selectedPage === IkioskMenuIds.LANGUGAEPAGE ? designsolidimg : designstrokeimg} alt="" width="250" className='footer_img' />
        </>
    );
}
export default React.memo(ThemeTwoFooter);